<section class="tw-w-full md:tw-w-[451px] tw-rounded-xl tw-p-6 tw-flex tw-flex-col tw-gap-6">
    <div>
        <mat-icon   
        ga-event-id="x_button_draft_click"
        ga-event-category="Draft Button"
        ga-event-label="X Button Draft Click"
        ga-track="track"
        class="tw-w-8 tw-h-8 tw-float-right" 
        [mat-dialog-close]="true"
        >
        close
        </mat-icon>
    </div>
    <div
        class="tw-font-semibold tw-text-xl tw-w-[95%] tw-text-center tw-mx-auto"
        *ngIf="data.noOfDrafts == 1"
    >
        {{ "NEW_APPLICATION.SINGLE_DRAFT_MSG" | translate }}
    </div>
    <div
        class="tw-font-semibold tw-text-xl tw-w-[95%] tw-text-center tw-mx-auto"
        *ngIf="data.noOfDrafts > 1"
    >
        {{ "NEW_APPLICATION.MULTI_DRAFT_MSG" | translate }}
    </div>
    <button
        ga-event-id="resume_button_draft_click"
        ga-event-category="Draft Button"
        ga-event-label="Resume Main Button Draft Click"
        ga-track="track"
        class="tw-btn-warning tw-py-2"
        (click)="resumeDraft(data.noOfDrafts)"
    >
        {{ "COMMON.RESUME" | translate }}
    </button>
    <button
        ga-event-id="start_new_button_draft_click"
        ga-event-category="Draft Button"
        ga-event-label="Start New Main Button Draft Click"
        ga-track="track"
        class="tw-btn tw-h-8 tw-mb-3 tw-text-[#8D8D8D]"
        (click)="startNewApp()"
    >
        {{ "NEW_APPLICATION.START_NEW_APP" | translate }}
    </button>
</section>
